import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  paymentMethodDepositsTable,
} from "../../../config/grid-column-defs";
import { getCustomerPaymentMethod ,getTransactionCustomerPaymentEvent} from "../../../api/transaction-type";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Checkbox,
  InputLabel,
  FormControl,
  FormControlLabel,
  FormGroup,
  Tabs,
  Tab,
  MenuItem,
  Select,
  Stack,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import PaymentEventViewDialog from "../../../components/PaymentEventView";

export default function PaymentMethod() {
  const dispatch = useDispatch();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);
  const [paymentEventData, setPaymentEventData] = useState([]);

  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  let obj = paymentMethodDepositsTable.find((o) => o.headerName === "EDIT");
  addAdditionalColumn(obj, dispatch);
  
  // useEffect(()=>{
  //   if(user.token){
  //     getTransactionPaymentMethodData()
  //   }
  // },[])
  async function getTransactionPaymentMethodData() {
     setLoading(true);
    try {
      const { data } = await getCustomerPaymentMethod(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data);
      setLoading(false);
      return {
        rows: data.data.data,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  
  const handleClickOpen = (id) => {
    setId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  function addAdditionalColumn(obj, dispatch) {
    if (obj === undefined) {
      paymentMethodDepositsTable.push({
        headerName: "EDIT",
        field: "actions",
        resizable: true,
        minWidth: 150,
        cellRendererFramework: (params) => (
          <Button
            className="viewLink"
            onClick={() => {
              handleClickOpen(params.data.view);
            }}
          >
            View
          </Button>
        ),
      });
    }
  }


  async function getTransactionPaymentEvent(limit, offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionCustomerPaymentEvent(user.token, {
        id: params.docNo,
        limit,
        offset
      });
      setLoading(false);
      setPaymentEventData(data.data.data);
      return {
        rows: data.data.data,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <Box className="viewDetilsBox">
          <Box
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-sub-bkg"
          >
            <Tab label="DEPOSITS" />
          </Tabs>
          <TabPanel value={tabIndex} index={0}>
            <AgGridPaginatedTable
              // getTableRows={getTransactionPaymentEvent}
              columns={paymentMethodDepositsTable}
              perPage={5}
              refreshCounter={0}
              onCellClicked={(params) => {
                if (params.colDef.field === "actions") {
                  setOpen(true);
                  setId(params.data.view);
                }
                return;
              }}
            />
            {/*FAM Asset History*/}
           </TabPanel>
          {/*Journal Reject Reason*/}
       
        </Box> 
      </Box>
      <PaymentEventViewDialog open={open} id={id} handleClose={handleClose} paymentEventData={paymentEventData} />
    </>
  );
}
